import type { PixelConfig } from '@/config';
import type { StorageService } from '@/services/storage';

import type { VisitorService } from './types';
import { generateVisitorId } from './visitor-id';

const DEFAULT_VISITOR_KEY = 'visitor';

export class VisitorServiceImpl implements VisitorService {
  private readonly storage: StorageService;

  private readonly storageKey: string;

  constructor(storage: StorageService, config: PixelConfig) {
    this.storage = storage;
    this.storageKey = config.storage.keys?.visitor ?? DEFAULT_VISITOR_KEY;
  }

  getVisitorId(): string | null {
    return this.storage.get<string>(this.storageKey);
  }

  ensureVisitorId(): string {
    const existing = this.getVisitorId();
    if (existing) return existing;

    const visitorId = generateVisitorId();
    this.storage.set(this.storageKey, visitorId);
    return visitorId;
  }

  clearVisitorId(): void {
    this.storage.remove(this.storageKey);
  }
}
